import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";
import { RuleBuilderPage } from "@/components/ai-consumer-research/brand-moderator/rules/rule-builder-page";
import { ChevronLeft } from "lucide-react";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/rules/create")({
  validateSearch: z.object({
    template: z.string().optional(),
  }),
  component: CreateRule,
});

function CreateRule() {
  const { template } = Route.useSearch();
  return (
    <section>
      <div className="flex items-center gap-4">
        <Link
          to="/dashboard/consumer-research/rules"
          className="flex size-9 items-center justify-center rounded-lg bg-muted text-foreground transition-colors hover:bg-muted/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          aria-label="Back to rule templates"
        >
          <ChevronLeft className="size-5" />
        </Link>
        <h2 className="text-xl font-semibold">Configure Rule</h2>
      </div>
      <RuleBuilderPage template={template} />
    </section>
  );
}
